import { Plus } from "lucide-react";

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({
  question,
  answer,
  isOpen,
  onToggle,
}: FAQItemProps) {
  return (
    <div className="tw-border-b tw-border-gray-200 tw-py-6">
      <button
        onClick={onToggle}
        className="tw-w-full tw-flex tw-justify-between tw-items-start tw-text-left tw-gap-6"
      >
        <span className="tw-text-lg tw-font-semibold tw-text-black">
          {question}
        </span>

        <span
          className={`tw-mt-1 tw-text-gray-600 tw-transition-transform tw-duration-300 ${
            isOpen ? "tw-rotate-45" : "tw-rotate-0"
          }`}
        >
          <Plus size={18} />
        </span>
      </button>

      {/* Animated content */}
      <div
        className={`tw-grid tw-transition-all tw-duration-300 tw-ease-in-out ${
          isOpen ? "tw-grid-rows-[1fr] tw-opacity-100" : "tw-grid-rows-[0fr] tw-opacity-0"
        }`}
      >
        <div className="tw-overflow-hidden">
          <p className="tw-mt-4 tw-text-gray-600 tw-leading-relaxed">
            {answer}
          </p>
        </div>
      </div>
    </div>
  );
}
